
import AddToCartError from './AddToCartError.vue';
import CartService from 'JS/services/CartService';
import HorizontalTextDivider from 'JS/components/HorizontalTextDivider.vue';
import Icon from 'JS/components/Icon.vue';
import Vue from 'vue';
import { CartUpdateResolutionType, IUpdateFulfillmentOptionRequest } from 'JS/types/Order';
import { Component, Prop } from 'vue-property-decorator';
import { fulfillmentOptionToString } from 'JS/helpers/FulfillmentHelper';
import { FulfillmentType } from 'JS/types/ProductDelivery';
import { icons } from 'JS/constants/icons';
import { PickupDeliveryErrorResponse } from 'JS/services/ProductService';

@Component({
	name: 'FulfillmentError',
	components: {
		Icon,
		HorizontalTextDivider,
		AddToCartError
	}
})
export default class FulfillmentError extends Vue {

	/* Props
	============================================*/
	@Prop({ type: Object as () => PickupDeliveryErrorResponse, required: true })
	readonly fulfillmentErrorInfo: PickupDeliveryErrorResponse;

	/* Computed
	============================================*/
	get fulfillmentOptionInCartString(): string {
		return fulfillmentOptionToString(this.fulfillmentErrorInfo.currentFulfillmentType);
	}

	get requestedFulfillmentOption(): string {
		return fulfillmentOptionToString(this.fulfillmentErrorInfo.restrictedFulfillmentType);
	}

	get hasDisclosure(): boolean {
		return this.fulfillmentErrorInfo.restrictedFulfillmentType === FulfillmentType.LocalDelivery;
	}

	get isMobile(): boolean {
		return this.$mq === 'mobile';
	}

	/* Data
	============================================*/
	readonly cartService = new CartService();

	removeIcon: string = icons.remove;
	error: string = null;

	/* Methods
	============================================*/
	async updateFulfillmentOptionForProducts() {
		this.error = '';
		const payload: IUpdateFulfillmentOptionRequest = {
			fulfillmentOption: this.fulfillmentErrorInfo.restrictedFulfillmentType
		};
		this.$emit('loading', true);

		const response = await this.cartService.updateFulfillmentOptionForProducts(payload);

		this.$emit('loading', false);

		if (response.resolutionType === CartUpdateResolutionType.Success) {
			return this.confirm(this.fulfillmentErrorInfo.restrictedFulfillmentType);
		}
		this.error = 'Oops, something went wrong. Please try again.';
	}

	confirm(fulfillmentType: FulfillmentType) {
		return this.$emit('confirm', fulfillmentType);
	}

	closeModal() {
		this.error = '';
		this.$emit('close');
	}
}
